import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import styled, { css } from 'styled-components';
import { LazyImage } from 'react-lazy-images';
var ActualImage = styled.img(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  border-radius: ", ";\n  ", ";\n"])), function (_ref) {
  var width = _ref.width;
  return width && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      width: ", "px;\n    "])), width);
}, function (_ref2) {
  var height = _ref2.height;
  return height && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      height: ", "px;\n    "])), height);
}, function (_ref3) {
  var circular = _ref3.circular;
  return circular ? '50%' : 0;
}, function (_ref4) {
  var visibility = _ref4.visibility;
  return visibility && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      visibility: ", ";\n    "])), visibility);
});
var PlaceholderImage = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n"])), function (_ref5) {
  var width = _ref5.width;
  return width && css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      width: ", "px;\n    "])), width);
}, function (_ref6) {
  var height = _ref6.height;
  return height && css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      height: ", "px;\n    "])), height);
});

var Image = /*#__PURE__*/function (_PureComponent) {
  _inherits(Image, _PureComponent);

  var _super = _createSuper(Image);

  function Image() {
    var _this;

    _classCallCheck(this, Image);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderPlaceholder", function (_ref7) {
      var ref = _ref7.ref;
      var _this$props = _this.props,
          height = _this$props.height,
          width = _this$props.width;
      return /*#__PURE__*/React.createElement(PlaceholderImage, {
        width: width,
        height: height,
        ref: ref
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderImage", function () {
      var _this$props2 = _this.props,
          className = _this$props2.className,
          circular = _this$props2.circular,
          height = _this$props2.height,
          imgAlt = _this$props2.imgAlt,
          url = _this$props2.url,
          visibility = _this$props2.visibility,
          width = _this$props2.width;
      return /*#__PURE__*/React.createElement(ActualImage, {
        visibility: visibility,
        circular: circular,
        width: width,
        height: height,
        src: url,
        className: className,
        alt: imgAlt
      });
    });

    return _this;
  }

  _createClass(Image, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          url = _this$props3.url,
          imgAlt = _this$props3.imgAlt;
      return /*#__PURE__*/React.createElement(LazyImage, {
        src: url,
        alt: imgAlt,
        placeholder: this.renderPlaceholder,
        actual: this.renderImage
      });
    }
  }]);

  return Image;
}(PureComponent);

export { Image as default };
Image.defaultProps = {
  circular: false,
  visibility: false,
  imgAlt: '',
  className: ''
};
//# sourceMappingURL=image.js.map